import React from "react";
import {
  AnalyticsGranularity,
  TrendingBucket,
} from "../../../api/analyticsAdmin";
import { deltaInfo } from "../../../helpers/searchTrending";
import { formatBucketTick } from "../../../helpers/searchTrend";
import { queryLabel } from "../../../helpers/searchAnalytics";
import DeltaBadge from "./DeltaBadge";

const TrendingBoard: React.FC<{
  buckets: TrendingBucket[];
  granularity: AnalyticsGranularity;
}> = ({ buckets, granularity }) => (
  <div className="bg-white rounded-lg shadow p-4 overflow-x-auto">
    <div className="flex gap-4 min-w-min">
      {buckets.map((bucket) => (
        <div key={bucket.bucketStart} className="w-56 shrink-0">
          <div className="text-sm font-medium text-gray-600 mb-2">
            {formatBucketTick(bucket.bucketStart, granularity)}
          </div>
          <ol className="space-y-1">
            {bucket.items.map((item) => (
              <li
                key={item.query}
                className="flex items-center justify-between gap-2 text-sm"
              >
                <span className="truncate">
                  <span className="text-gray-400 mr-1">{item.rank}.</span>
                  {queryLabel(item)}
                </span>
                <DeltaBadge info={deltaInfo(item)} />
              </li>
            ))}
          </ol>
        </div>
      ))}
    </div>
  </div>
);

export default TrendingBoard;
